import { defineMessages, type MessageDescriptor } from 'react-intl';

const intlMessages = {
	switchSiteLabel: {
		id: 'twg-microsite.siteSwitcher.switchSiteLabel',
		defaultMessage: 'Switch site',
		description: 'Accessible label and tooltip for the site switcher trigger button',
	},
	switchSiteHeading: {
		id: 'twg-microsite.siteSwitcher.switchSiteHeading',
		defaultMessage: 'Switch site',
		description: 'Heading shown at the top of the site switcher dropdown menu',
	},
} as const;

export const messages: typeof intlMessages = defineMessages(intlMessages) satisfies Record<
	string,
	MessageDescriptor
>;
